// AI Visibility ölçüm projesi olan markalar (ai_visibility.projects.owner_brand_ids ile aynı tutulmalı).
// Bunlar paneli görür; diğer markalar /ai-visibility'de tanıtım sayfasını (AiVisibilityLanding) görür.
export const AI_VISIBILITY_BRAND_IDS = new Set([
  '44e35dfe-0186-495d-a0cc-db5e7e459ab7', // Yataş Bedding
  'dfcf54dd-b00d-434a-be1e-27b6484848eb', // Divanev
  '7fc8e68d-f2ba-4101-95f7-acece386ab8f', // Puffy
  'ccb2364b-e4e1-4f7f-944a-44cc9a839c6e', // EnzaHome
  '9e3c368d-d70d-4ba4-9506-fa0f65b526f7', // HUPALUPA Eğlence
  '7f97784c-d406-4400-830b-8d13a7c21d5f', // Multinet
  '67b7c414-1e1c-4823-a952-12f3cfee5369', // Baqa
  '13b58e06-8266-4a5b-8113-2de43aa686e1', // Europcar
  '51a90886-3370-41c5-bc95-397554db7cf4', // Triomobil → triomobil projesi (id 8), 5 Eki 2026
  'b09471ca-a209-47ee-899f-62f48bc39f30', // glowy → derma-tr sektör projesi, YALNIZ Efe (aşağıda)
  'cfedee67-2f2e-47b6-92e9-086be019b6c0', // inviter → kozmetik-tr sektör projesi (id 15), YALNIZ Efe, 16 Eki 2026 glowy'den taşındı
  'e1c18e45-15db-4200-8fca-b150d15ac7aa', // Propia → derma-tr sektör projesi, Propia (brands.id 870) bakarken own, 21 Eki 2026
]);

// Markaya bağlı ama kişiye kilitli projeler. Backend aynı kuralı projects.settings.allowedEmails ile uygular.
// glowy markasına başka kullanıcılar da erişebiliyor (dpedijital ADMIN); derma-tr'yi yalnız Efe görür (3 Eki 2026).
const EMAIL_LOCKED = {
  'b09471ca-a209-47ee-899f-62f48bc39f30': ['efe@heyglowy.com', 'efe@glowytics.com'],
  'cfedee67-2f2e-47b6-92e9-086be019b6c0': ['efe@heyglowy.com', 'efe@glowytics.com'],
  // Propia derma-tr'yi paylaşıyor → aynı allowedEmails kilidi; Propia ekibi eklenince iki yere de e-posta eklenir
  'e1c18e45-15db-4200-8fca-b150d15ac7aa': ['efe@heyglowy.com', 'efe@glowytics.com'],
};

export const hasAiVisibility = (brandId, email) => {
  if (!brandId || !AI_VISIBILITY_BRAND_IDS.has(brandId)) return false;
  const lock = EMAIL_LOCKED[brandId];
  return !lock || lock.includes(String(email || '').toLowerCase());
};

// Persona konuşmaları (derma-tr glowy'de, kozmetik-tr inviter'da) ve yalnız kilitli e-postalarda görünür.
export const PERSONA_BRAND_IDS = new Set([
  'b09471ca-a209-47ee-899f-62f48bc39f30', // glowy → derma-tr
  'cfedee67-2f2e-47b6-92e9-086be019b6c0', // inviter → kozmetik-tr (K01–K12), 16 Eki 2026
  'e1c18e45-15db-4200-8fca-b150d15ac7aa', // Propia → derma-tr, 21 Eki 2026
]);

export const hasPersonas = (brandId, email) => !!brandId && PERSONA_BRAND_IDS.has(brandId) && hasAiVisibility(brandId, email);

// Yapılacaklar listesi (SEO/içerik kontrol listesi, 2 Kas 2026) — yalnız Yataş Grup projesi sahipleri.
// Backend: /api/ai-visibility/todo (ai_visibility.todo_topics). Yeni proje = betikle liste üret + buraya ekle.
export const TODO_BRAND_IDS = new Set([
  '44e35dfe-0186-495d-a0cc-db5e7e459ab7', // Yataş Bedding
  '7fc8e68d-f2ba-4101-95f7-acece386ab8f', // Puffy
  'ccb2364b-e4e1-4f7f-944a-44cc9a839c6e', // EnzaHome
  'dfcf54dd-b00d-434a-be1e-27b6484848eb', // Divanev
]);
export const hasTodo = (brandId, email) => !!brandId && TODO_BRAND_IDS.has(brandId) && hasAiVisibility(brandId, email);
